var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.125 0h-5C12.09 0 11.25.84 11.25 1.875v5c0 1.035.84 1.875 1.875 1.875h3.125v2.5c0 1.379-1.121 2.5-2.5 2.5h-.313c-.519 0-.937.418-.937.938v1.874c0 .52.418.938.938.938h.312c3.453 0 6.25-2.797 6.25-6.25V1.875C20 .84 19.16 0 18.125 0zM6.875 0h-5C.84 0 0 .84 0 1.875v5C0 7.91.84 8.75 1.875 8.75H5v2.5c0 1.379-1.121 2.5-2.5 2.5h-.313c-.519 0-.937.418-.937.938v1.874c0 .52.418.938.938.938H2.5c3.453 0 6.25-2.797 6.25-6.25V1.875C8.75.84 7.91 0 6.875 0z",
    transform: "translate(2 3)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.69cd90f6051ecab25e66afee6743fd1f.svg";
export { ForwardRef as ReactComponent };